export default __webpack_public_path__ + "static/media/d_wdt_c_3.10421241.mp3";